import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MfaVerify from "./pages/MfaVerify";
import TotpSetup from "./pages/TotpSetup";
import Products from "./pages/Products";
import OrderProduct from "./pages/OrderProduct";
import QROrder from "./pages/QROrder";
import Account from "./pages/Account";
import AddCredits from "./pages/AddCredits";
import StripeSuccess from "./pages/StripeSuccess";
import Admin from "./pages/Admin";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-farm-cream dark:bg-gray-950
                          transition-colors duration-200">
            <Navbar />
            <main className="max-w-2xl mx-auto px-4 py-8">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/mfa-verify" element={<MfaVerify />} />
                <Route path="/totp-setup" element={<TotpSetup />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<OrderProduct />} />
                {/* Legacy route — old QR codes and bookmarks still work */}
                <Route path="/order" element={<Navigate to="/products" replace />} />
                <Route path="/qr-order" element={<QROrder />} />
                <Route path="/account" element={<Account />} />
                <Route path="/add-credits" element={<AddCredits />} />
                <Route path="/stripe-success" element={<StripeSuccess />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
